import React, { useContext, useEffect, useMemo, useState } from "react";
import createPreview from "../Helpers/createPreview.js";
import useMediaQueries from "hooks/useMediaQueries.js";
import UploadListItem from "./UploadListItem.js";
import { SizeMe } from "react-sizeme";
import { UploadGalleryItemWithMemo } from "./UploadGalleryItem.js";
import { useUploader } from "contexts/uploaderContext/uploaderContext.js";
import { UploaderContext } from "./HomeUploader.js";
import { useContent } from "contexts/contentContext/contentContext.js";
import usePaginationUploader from "../Helpers/usePaginationUploader.js";

const UploadGallery = () => {
  const { filesProgress } = useContext(UploaderContext);

  const { mobileCondition, leptopCondition } = useMediaQueries();

  const [previews, setPreviews] = useState({});
  const { getIsUppy } = useUploader();

  const { fileList, UplaoderPaginator, pageNum } = usePaginationUploader();

  const generatePreviews = async (fileList) => {
    for (let i = 0; i < fileList.length; i++) {
      if (previews[fileList[i].id]) continue;
      const file = fileList[i];
      const fileData = getIsUppy() ? file.data : file.file;

      if (fileData.type.includes("video")) continue;

      const preview = await createPreview(fileData, fileData.type);

      setPreviews((prevPreviews) => ({
        ...prevPreviews,
        [file.id]: preview,
      }));

      await new Promise((resolve) => setTimeout(resolve, 100)); // Add a delay of 100ms
    }
  };

  const generateAndSetPreviews = async () => {
    const batchSize = 5;
    for (let i = 0; i < fileList.length; i += batchSize) {
      const batchFiles = fileList.slice(i, i + batchSize);
      await generatePreviews(batchFiles, setPreviews);
    }
  };

  useEffect(() => {
    generateAndSetPreviews();
  }, [pageNum, fileList.length]);

  return (
    <SizeMe refreshMode="throttle" refreshRate={500}>
      {({ size }) => {
        let itemsPerRow;
        let i = 0;
        const minSize = leptopCondition ? 120 : 150;
        do {
          itemsPerRow = i;
          i = i + 1;
        } while (size.width / i > minSize);
        return (
          <div className="preview-gallery">
            {fileList.map((file) => {
              return (
                <UploadGalleryItemWithMemo
                  {...{
                    file,
                    size,
                    itemsPerRow: mobileCondition ? 3 : itemsPerRow,
                    progress: filesProgress[file.id],
                    preview: previews[file.id],
                  }}
                  key={file.id}
                />
              );
            })}
            <UplaoderPaginator />
          </div>
        );
      }}
    </SizeMe>
  );
};

const UploadList = () => {
  const { getUploading } = useUploader();

  const { getTextByKey } = useContent();

  const { filesProgress } = useContext(UploaderContext);

  const { fileList, UplaoderPaginator } = usePaginationUploader();

  return (
    <div className="upload-list-container">
      <div className="list-file-item header">
        <div className="list-file-name">{getTextByKey("name")}</div>
        <div className="flex-spacer" />
        <div className="list-file-info">{getTextByKey("size")}</div>
        {getUploading() ? (
          <div className="list-file-info">{getTextByKey("status")}</div>
        ) : null}
        {getUploading() ? null : <div className="list-file-info"></div>}
      </div>
      {fileList.map((file) => (
        <UploadListItem
          file={file}
          key={file.id}
          progress={filesProgress[file.id]}
        />
      ))}
      <UplaoderPaginator className="list-pagination" />
    </div>
  );
};

const UploadFilesPreview = ({ listView }) => {
  return !listView ? <UploadGallery /> : <UploadList />;
};

export default UploadFilesPreview;
